import * as React from 'react';
import { clsx as cx } from 'clsx';

import { TFooterType } from '../../types/footerType';

import * as styles from './MobileFooterLayout.css';

interface IMobileFooterLayoutProps extends React.PropsWithChildren {
  type: TFooterType;
  isRedesign?: boolean;
}

export const MobileFooterLayout: React.FC<IMobileFooterLayoutProps> = ({ type, children, isRedesign }) => {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  const shouldUseRedesign = mounted ? isRedesign : false;

  return (
    <div
      className={cx(
        styles['footer-mobile'],
        type === 'adaptive' && styles['footer-mobile--adaptive'],
        shouldUseRedesign && styles['footer-mobile--redesign'],
      )}
    >
      {children}
    </div>
  );
};
